"use strict";
/*
 * Created on 10 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CRPFlag_1 = require("../../cleaning/model/CRPFlag");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var FlagSet_1 = require("../../core/model/FlagSet");

var ProductPrice_1 = require("../../product/model/ProductPrice");

var CompetitorReferentialPriceState_1 = require("./CompetitorReferentialPriceState");
/**
 * @author Jaroslav Sevcik
 * @author Radek Beran
 */


var CompetitorReferentialPrice =
/*#__PURE__*/
function (_ProductPrice_1$Produ) {
  _inherits(CompetitorReferentialPrice, _ProductPrice_1$Produ);

  /**
   * @param id the internal id
   * @param priceZoneId
   * @param competitorsProductId
   * @param competitorId
   * @param date the date of the price approval, for new CRPs it is the date of creation
   * @param value computed competitor referential price
   * @param modifiedValue value modified by size ratio and size charger
   * @param state if it is the actual referential price, the newly suggested one or historical data
   * @param promo if promo prices were also used to compute this CRP
   * @param lastPriceDate a date of the last competitor price used to compute this CRP
   * @param flags
   */
  function CompetitorReferentialPrice(id, priceZoneId, competitorsProductId, competitorId, date, value, modifiedValue, state, promo, lastPriceDate) {
    var _this;

    var flags = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : new FlagSet_1.FlagSet(CRPFlag_1.CRPFlag);

    _classCallCheck(this, CompetitorReferentialPrice);

    // LOG-5292: Setting VAT value to null, VAT is used only in regular/sellout/final prices
    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorReferentialPrice).call(this, value, null));
    _this.id = id;
    _this.priceZoneId = priceZoneId;
    _this.competitorsProductId = competitorsProductId;
    _this.competitorId = competitorId;
    _this.date = date;
    _this.value = value;
    _this.modifiedValue = modifiedValue;
    _this.state = state;
    _this.promo = promo;
    _this.lastPriceDate = lastPriceDate;
    _this.flags = flags;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to CRP.
   */


  _createClass(CompetitorReferentialPrice, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new CompetitorReferentialPrice(mat.id, mat.priceZoneId, mat.competitorsProductId, mat.competitorId, mat.date, mat.value, mat.modifiedValue, mat.state, mat.promo, mat.lastPriceDate, mat.flags);
    }
  }]);

  return CompetitorReferentialPrice;
}(ProductPrice_1.ProductPrice);

exports.CompetitorReferentialPrice = CompetitorReferentialPrice;

CompetitorReferentialPrice.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(CompetitorReferentialPrice.name);
  return {
    id: builder.str('id'),
    priceZoneId: builder.str('priceZoneId'),
    competitorsProductId: builder.str('competitorsProductId'),
    competitorId: builder.str('competitorId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    value: builder.bigNum('value'),
    modifiedValue: builder.bigNum('modifiedValue'),
    vatId: builder.opt(builder.str('vatId')),
    state: builder.senum('state', CompetitorReferentialPriceState_1.CompetitorReferentialPriceState, 'seq'),
    promo: builder.bool('promo'),
    lastPriceDate: builder.date('lastPriceDate', DateParser_1.DateParser.ISO_PATTERN),
    flags: builder.flags('flags', CRPFlag_1.CRPFlag)
  };
}();